/**
 * O campo "Assinatura registrada em" do formulário do protocolo (E84.F4).
 *
 * A linha de status do comprovante, lida com o fuso explícito; o mesmo
 * controle `datetime-local` em UTC dos eventos da trilha. Quando a leitura
 * presumiu o sinal do fuso (glifo ilegível na camada de texto), a nota aparece
 * ao lado — e some assim que o perito toca no valor: editar é confirmar.
 */
import { Field, Input } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';

import type { ProtocoloFormState } from './protocolo_form_state';

const t = ptBR.exameEletronico.form;

export function CampoRegistroDaAssinatura({
  idPrefix,
  state,
  patch,
  disabled,
}: {
  idPrefix: string;
  state: ProtocoloFormState;
  patch: (parcial: Partial<ProtocoloFormState>) => void;
  disabled: boolean;
}): JSX.Element {
  const id = `${idPrefix}-registro`;
  const hint = state.assinaturaRegistradaEmFusoPresumido
    ? t.assinaturaRegistradaEmPresumido
    : t.assinaturaRegistradaEmHint;
  return (
    <div className="mb-sc-3 grid gap-sc-3 sm:grid-cols-2">
      <Field htmlFor={id} label={t.assinaturaRegistradaEm} description={hint}>
        <Input
          id={id}
          data-testid={id}
          data-fuso-presumido={state.assinaturaRegistradaEmFusoPresumido ? 'true' : 'false'}
          type="datetime-local"
          className="font-mono"
          value={state.assinaturaRegistradaEm}
          disabled={disabled}
          onChange={(e) =>
            patch({
              assinaturaRegistradaEm: e.target.value,
              assinaturaRegistradaEmFusoPresumido: false,
              assinaturaRegistradaEmSemSegundos: false,
            })
          }
        />
      </Field>
    </div>
  );
}
